// author-liumingyang 2022-3-8  经分
import React, { useMemo } from 'react';
import { mathFormat } from '@/pages/opinion/utils';
import { getLocale, useIntl } from 'umi';
import EChartCommon from '@/pages/opinion/components/EChartCommon';

export default (props) => {
  const { formatMessage } = useIntl();
  const {
    data: {
      negative_mentions = 0,
      neutral_mentions = 0,
      positive_mentions = 0,
    },
  } = props;

  const ref = React.useRef(null as any);

  const option = useMemo(() => {
    const color: string[] = [];
    const legendData: string[] = [];
    const seriesData: any[] = [];

    if (positive_mentions) {
      color.push('#69D19C');
      legendData.push(formatMessage({ id: 'Positive' }));
      seriesData.push({
        value: positive_mentions,
        name: formatMessage({ id: 'Positive' }),
      });
    }
    if (neutral_mentions) {
      color.push('#6E7794');
      legendData.push(formatMessage({ id: 'Neutral' }));
      seriesData.push({
        value: neutral_mentions,
        name: formatMessage({ id: 'Neutral' }),
      });
    }

    if (negative_mentions) {
      color.push('#F17C86');
      legendData.push(formatMessage({ id: 'Negative' }));
      seriesData.push({
        value: negative_mentions,
        name: formatMessage({ id: 'Negative' }),
      });
    }

    const option = {
      color,
      tooltip: {
        show: false,
      },
      legend: {
        data: legendData,
      },
      series: [
        {
          stillShowZeroSum: false,
          type: 'pie',
          radius: '50%',
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },

          labelLayout: (params) => {
            const isLeft =
              params.labelRect.x <
              ref?.current?.getEchartsInstance()?.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points,
            };
          },
          label: {
            color: 'auto',
            alignTo: 'edge',
            formatter: (params) => {
              return (
                '{value| ' +
                params.name +
                '}: {a|' +
                mathFormat(params.value) +
                '(' +
                params.percent.toFixed(2) +
                '%)}\n{hr|}\n{a|}'
              );
            },
            minMargin: 5,
            edgeDistance: 10,
            // lineHeight: 5,
            rich: {
              a: {
                // color: '#999',
                lineHeight: 20, //设置最后一行空数据高度，为了能让延长线与hr线对接起来
                align: 'center',
              },
              hr: {
                //设置hr是为了让中间线能够自适应长度
                borderColor: 'auto', //hr的颜色为auto时候会主动显示颜色的
                width: '105%',
                borderWidth: 0.5,
                height: 0.5,
              },
              per: {
                //用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
                padding: [4, 0],
              },
            },
          },
        },
      ],
    };

    return option;
  }, [negative_mentions, neutral_mentions, positive_mentions, getLocale()]);

  return (
    <EChartCommon
      optionsProps={{ type: 'pie' }}
      ref={ref}
      height={300}
      options={option}
      lazyUpdate
    />
  );
};
